// Router Class
class Router {
  screenToPageMapping: screenToPageObjectInterface
  linkElement: HTMLElement
  routerProps: RouterProps

  constructor(
    screenToPageMapping: screenToPageObjectInterface,
    routerProps: RouterProps
  ) {
    this.screenToPageMapping = screenToPageMapping
    this.routerProps = routerProps
  }

  setMappings(newMappings: screenToPageObjectInterface) {
    this.screenToPageMapping = newMappings
  }

  async handleInitialRender() {
    let path = window.location.pathname
    if (path == '/') path = '/home'
    const screenName = path.split('/')[1]
    this.linkElement = this.findNavBtnWithLinkTo(screenName)
    this.linkElement.classList.add('selected')
    this.changeAddress(screenName, { currentScreenName: screenName })
    await this.screenToPageMapping[screenName].transitionIn()
    this._setActiveScreen(screenName)
  }

  findNavBtnWithLinkTo(screenName: string): HTMLElement {
    return document.querySelector(`.nav-button[data-link=${screenName}]`)
  }

  _findParentNodeWithNavClass = (node: HTMLElement) => {
    if (
      node.classList.contains('nav-button') ||
      node.classList.contains('nav-link')
    ) {
      return node
    }

    // Recursing through the parent elements
    if (
      node.parentNode &&
      ((<HTMLElement>node.parentNode).classList.contains('nav-button') ||
        (<HTMLElement>node.parentNode).classList.contains('nav-link'))
    ) {
      return node.parentNode
    }

    return this._findParentNodeWithNavClass(node.parentElement)
  }

  changeAddress(screenName: string, state: object) {
    history.pushState(state, `Apoorv Agarwal | ${screenName}`, screenName)
  }
  replaceAddress(screenName: string, state: object) {
    history.replaceState(state, `Apoorv Agarwal | ${screenName}`, screenName)
  }

  _handleScreenTransition = async (
    currentScreenName: string,
    nextScreenName: string
  ) => {
    this._removeActiveScreen(currentScreenName)
    this.routerProps.onEnter()
    // Transitions
    await this.screenToPageMapping[currentScreenName].transitionOut()
    await this.screenToPageMapping[nextScreenName].transitionIn()
    this.routerProps.onExit()

    this._setActiveScreen(nextScreenName)
  }

  _setActiveScreen(screenName: string) {
    document.getElementById(screenName).classList.add('activeScreen')
  }
  _removeActiveScreen(screenName: string) {
    document.getElementById(screenName).classList.remove('activeScreen')
  }

  to = (e: Event) => {
    const currentScreenName = this.linkElement.dataset.link
    this.linkElement.classList.remove('selected')
    this.linkElement = this._findParentNodeWithNavClass(
      <HTMLElement>e.target
    ) as HTMLElement
    if (!this.linkElement.classList.contains('nav-button')) {
      this.linkElement = this.findNavBtnWithLinkTo(
        this.linkElement.dataset.link
      )
    }
    this.linkElement.classList.add('selected')
    const nextScreenName = this.linkElement.dataset.link
    if (nextScreenName == currentScreenName) return
    this.changeAddress(nextScreenName, { currentScreenName: nextScreenName })
    this._handleScreenTransition(currentScreenName, nextScreenName)
  }

  handlePopState = (_: PopStateEvent) => {
    const nextScreenName = document.location.pathname.split('/')[1]
    const currentScreenName = this.linkElement.dataset.link
    if (currentScreenName === nextScreenName) return
    this.linkElement.classList.remove('selected')
    this.linkElement = this.findNavBtnWithLinkTo(nextScreenName)
    this.linkElement.classList.add('selected')
    this.replaceAddress(nextScreenName, { currentScreenName: nextScreenName })
    this._handleScreenTransition(currentScreenName, nextScreenName)
  }
}

export default Router
